import { render, staticRenderFns } from "./BenefitsOverview.vue?vue&type=template&id=3ab2fec2&scoped=true&lang=html&"
import script from "./BenefitsOverview.vue?vue&type=script&lang=js&"
export * from "./BenefitsOverview.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsOverview.vue?vue&type=style&index=0&id=3ab2fec2&lang=sass&scoped=true&"
import style1 from "./BenefitsOverview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2fec2",
  null
  
)

export default component.exports